import styled from "styled-components";
import { Typography } from "antd";

const { Title } = Typography;
export const StyledTitle = styled(Title)`
  margin-top: 0;
  margin-bottom: 6px;
  padding-top: 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const StyledText = styled.p`
  color: #808080;
  margin: 0 0 6px 0;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
